import React from 'react';
import style from './style';
import EAButton from "../../../common/EAButton";

const SaveButton = ({onClick,icon, children}) => {
  const {classes} = style();
  return <EAButton
    className={classes.root}
    onClick={onClick}
    content={children}
  />
}

export default SaveButton;